import React, { useState, useEffect } from "react";
import { Button, Input, Switch, Divider, Upload } from "antd";
import {
  UploadOutlined,
  CheckOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { uploadImage } from "../../../../utils/utility";
import { useProjectState } from "../../../../context/stateContext";

const EditTabsRoomServiceSettings = ({
  sendRoomServiceState,
  organization,
}) => {
  const [roomServiceEnabled, setRoomServiceEnabled] = useState(null);
  const [roomDirectoryMyMenuText, setRoomDirectoryMyMenuText] = useState(null);
  const [roomDirectoryText, setRoomDirectoryText] = useState(null);
  const [roomDirectoryFooterText, setRoomDirectoryFooterText] = useState(null);
  const [roomDirectoryUrl, setRoomDirectoryUrl] = useState(null);
  const [footerImage, setFooterImage] = useState(null);
  const { openEditOrganizationModal } = useProjectState();

  const roomServiceState = {
    roomServiceEnabled,
    roomDirectoryMyMenuText,
    roomDirectoryText,
    roomDirectoryFooterText,
    roomDirectoryUrl,
    footerImage,
  };

  useEffect(() => {
    sendRoomServiceState(roomServiceState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(roomServiceState)]);

  useEffect(() => {
    setRoomServiceEnabled(
      organization?.myMenuConfiguration?.roomServiceConfiguration
        ?.roomServiceEnabled
    );
    setRoomDirectoryMyMenuText(
      organization?.myMenuConfiguration?.roomServiceConfiguration
        ?.roomDirectoryMyMenuText
    );
    setRoomDirectoryText(
      organization?.myMenuConfiguration?.roomServiceConfiguration
        ?.roomDirectoryText
    );
    setRoomDirectoryFooterText(
      organization?.myMenuConfiguration?.roomServiceConfiguration
        ?.roomDirectoryFooterText
    );
    setRoomDirectoryUrl(
      organization?.myMenuConfiguration?.roomServiceConfiguration
        ?.roomDirectoryUrl
    );
    setFooterImage(
      organization?.myMenuConfiguration?.roomServiceConfiguration?.footerImage
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organization, openEditOrganizationModal]);

  return (
    <>
      <div className="admin-organization-edit-sections">
        <div>
          <label
            style={{ width: "300px" }}
            className="admin-organization-edit-input-label"
          >
            RoomService Enable
          </label>
          <Switch
            checkedChildren={<CheckOutlined />}
            unCheckedChildren={<CloseOutlined />}
            checked={roomServiceEnabled}
            onChange={(value) => setRoomServiceEnabled(value)}
          />
        </div>
      </div>
      <Divider />
      {roomServiceEnabled && (
        <>
          <div className="admin-organization-edit-sections">
            <div className="admin-organization-full-width">
              <label className="admin-organization-edit-input-label">
                RoomDirectoryMyMenuText
              </label>
              <Input
                value={roomDirectoryMyMenuText}
                onChange={(e) => setRoomDirectoryMyMenuText(e.target.value)}
              />
            </div>
            <div className="admin-organization-full-width">
              <label className="admin-organization-edit-input-label">
                RoomDirectoryText
              </label>
              <Input
                value={roomDirectoryText}
                onChange={(e) => setRoomDirectoryText(e.target.value)}
              />
            </div>
          </div>
          <div className="admin-organization-edit-sections">
            <div className="admin-organization-full-width">
              <label className="admin-organization-edit-input-label">
                RoomDirectoryFooterText
              </label>
              <Input
                value={roomDirectoryFooterText}
                onChange={(e) => setRoomDirectoryFooterText(e.target.value)}
              />
            </div>
            <div className="admin-organization-full-width">
              <label className="admin-organization-edit-input-label">
                RoomDirectoryUrl
              </label>
              <Input
                value={roomDirectoryUrl}
                onChange={(e) => setRoomDirectoryUrl(e.target.value)}
              />
            </div>
          </div>
          <Divider />

          <div className="admin-organization-edit-sections">
            <div className="admin-organization-full-width">
              <p className="admin-organization-image-text">Футър снимка</p>
              <img
                className="admin-organization-uploaded-image"
                src={`data:image/jpeg;base64,${footerImage?.substring(
                  footerImage?.indexOf(",") + 1
                )}`}
                alt="footer"
              />
              <div className="admin-organization-edit-upload-image-container">
                <Upload
                  showUploadList={false}
                  onChange={(e) => uploadImage(e, setFooterImage)}
                  accept="image/png,image/jpeg,image/webp"
                  beforeUpload={() => false}
                >
                  <Button
                    className="admin-organization-upload-button"
                    type="primary"
                    icon={<UploadOutlined />}
                    size="large"
                  >
                    Качи файл
                  </Button>
                </Upload>
              </div>
            </div>
          </div>
        </>
      )}
      <Divider />
    </>
  );
};

export default EditTabsRoomServiceSettings;
